module.exports = __webpack_public_path__ + "static/media/LogoStairs.c2b63e7e.svg";